/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */


import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import { getStandardsOptions } from '../../../constants/standards-frameworks';
import { ExtraFeature, FeatureStability } from '@g17eco/molecules/feature-stability';
import { MultipleSelectProps } from '@g17eco/molecules/select/MultipleSelect';
import { SelectFactory, SelectTypes } from '@g17eco/molecules/select/SelectFactory';


type changeFn = (codes: string[] | undefined) => void

interface Props {
  standardCodes: string[] | undefined;
  onChange: changeFn;
  selectProps?: Partial<Omit<MultipleSelectProps<string>, 'onChange' | 'values' | 'options' | ''>>;
}

const options = getStandardsOptions();


export const StandardSelector = ({ standardCodes = [], onChange, selectProps }: Props) => {

  return (
    <FormGroup>
      <Label for='prefferedAltCodes'>Preferred Standards <FeatureStability feature={ExtraFeature.PreferredStandards} /></Label>
      <SelectFactory
        selectType={SelectTypes.MultipleSelect}
        placeholder={'Standards'}
        options={options}
        noOptionsMessage='No standards available for selection'
        values={standardCodes}
        onChange={(values: string[]) => onChange(values)}
        {...selectProps}
      />
    </FormGroup>

  )
}
